var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"parent"},[_c('div',{staticClass:"divTitle"},[_c('div',{staticClass:"divTitleDisplay"},[_c('img',{attrs:{"src":require("../../img/baseStart.png")}}),_c('span',[_vm._v(_vm._s(_vm.title))]),_c('img',{attrs:{"src":require("../../img/baseEnd.png")}})]),_c('div',{staticClass:"divDescribe"},[_vm._v(_vm._s(_vm.desc))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }